/* Maison Lige – NL-laag (alleen locale nl).
   Wordt uitsluitend geladen via layout/theme.liquid binnen {% if request.locale.iso_code == 'nl' %}.
   Vertaalt de teksten die lige.js / lige-cart.js hardcoded in het Engels injecteren (vertrouwensblok en
   kortingsbadge in de winkelwagenlade, aanbiedingstitels, ARIA-labels van menu en upsell-pijlen).
   lige.js, lige-cart.js en lige.css zelf blijven ongewijzigd. */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('lige-nl')) return;

  // CSS-teksten van de voortgangsbalk in de winkelwagenlade (lige.css heeft hier EN + een body.lige-es-variant;
  // dit is de NL-tegenhanger, alleen onder body.lige-nl — lige.css zelf blijft ongewijzigd)
  var css = document.createElement('style');
  css.id = 'lige-nl-css';
  css.textContent =
    'body.lige-nl .kaching-cart .kaching-cart__announcement-bar:before{content:"Je hebt gratis verzending!"}' +
    'body.lige-nl .kaching-cart .kaching-cart__tiered-promotions-bar:after{content:"\\2705  Gratis verzending"}';
  document.head.appendChild(css);

  // Exacte teksten in het vertrouwensblok (.lige-cart-trust) van de winkelwagenlade
  var TRUST = {
    'BUY 1, GET 1 FREE': '1+1 GRATIS',
    '30-Day Money-Back Guarantee': '30 dagen geld-terug-garantie',
    'Free Shipping': 'Gratis verzending',
    'Secure Checkout': 'Veilig afrekenen'
  };
  // Exacte ARIA-labels die lige.js zet
  var ARIA = {
    'Open menu': 'Menu openen',
    'Close menu': 'Menu sluiten',
    'Previous': 'Vorige',
    'Next': 'Volgende'
  };

  // "Buy 1, Get 1 Free" (titel van de automatische korting en aanbiedingstitel) → "1+1 GRATIS",
  // overal op de pagina: kortingsbadge in de lade, offer-titel op de productpagina, enz.
  // Alleen tekstknopen die in hun geheel deze tekst zijn (hoofdletters, "One" en een ! maken niet uit).
  var BOGO = /^buy\s+(1|one)\s*,?\s*get\s+(1|one)\s+free\s*!?$/i;
  var BOGO_NL = '1+1 GRATIS';
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 };

  function fixTrust(root) {
    var boxes = root.querySelectorAll ? root.querySelectorAll('.lige-cart-trust') : [];
    for (var i = 0; i < boxes.length; i++) {
      var walker = document.createTreeWalker(boxes[i], NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue.trim();
        if (t && Object.prototype.hasOwnProperty.call(TRUST, t)) node.nodeValue = TRUST[t];
      }
    }
  }

  function fixBogo(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (p && SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        var v = n.nodeValue;
        return v && v.length < 40 && BOGO.test(v.trim()) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var hits = [], node;
    while ((node = walker.nextNode())) hits.push(node);
    for (var i = 0; i < hits.length; i++) hits[i].nodeValue = hits[i].nodeValue.replace(hits[i].nodeValue.trim(), BOGO_NL);
  }

  function fixAria(root) {
    var els = root.querySelectorAll ? root.querySelectorAll('[aria-label]') : [];
    for (var i = 0; i < els.length; i++) {
      var a = els[i].getAttribute('aria-label');
      if (Object.prototype.hasOwnProperty.call(ARIA, a)) els[i].setAttribute('aria-label', ARIA[a]);
      else if (a && BOGO.test(a.trim())) els[i].setAttribute('aria-label', BOGO_NL);
    }
  }

  function run() { fixTrust(document); fixBogo(document.body); fixAria(document); }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; run(); });
  }

  run();
  new MutationObserver(schedule).observe(document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label']
  });
})();
